import React from 'react';
import { number, arrayOf, shape, string, func } from 'prop-types';
import { Star } from '@magalu/stereo-ui-icons';
import { Container, Main, Score, Description, Divider } from './review-stats.styles';
import Button from '../../atoms/Button';
import { RatingLine } from '../../molecules';

function ReviewStats({
  average,
  count: total,
  distribution,
  actionLabel,
  onReviewButtonClick
}) {
  const desc = total > 1 ? `${total} avaliações` : `${total} avaliação`;
  distribution.sort((a, b) => b.value - a.value);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    mb: [3, 3, 3]
  }, /*#__PURE__*/React.createElement(Main, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Score, {
    "data-testid": "stat-score"
  }, average.toFixed(1)), /*#__PURE__*/React.createElement(Star, {
    width: "50px",
    height: "50px",
    color: "#FFCC03"
  })), /*#__PURE__*/React.createElement(Description, {
    "data-testid": "stat-desc"
  }, desc)), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("ul", null, distribution == null ? void 0 : distribution.map(item => /*#__PURE__*/React.createElement(RatingLine, {
    key: item.value,
    id: item.value,
    score: item.count,
    count: item.count,
    max: total
  })))), !!actionLabel && /*#__PURE__*/React.createElement(Button, {
    full: true,
    variation: "fill",
    size: "medium",
    color: "primary",
    onClick: e => onReviewButtonClick(e, {
      average,
      distribution,
      desc,
      total
    })
  }, actionLabel));
}

ReviewStats.defaultProps = {
  actionLabel: 'Quero avaliar',
  average: 0,
  count: 0,
  distribution: [],
  onReviewButtonClick: () => ({})
};
process.env.NODE_ENV !== "production" ? ReviewStats.propTypes = {
  actionLabel: string,
  average: number,
  count: number,
  distribution: arrayOf(shape({
    value: number,
    count: number
  })),
  onReviewButtonClick: func
} : void 0;
export default ReviewStats;